function arrayFirst(array) {
  return array != null ? array[0] : undefined;
}

exports.arrayFirst = arrayFirst;